import { iFirestoreProfilePicStorage, StorageFile } from '../firestore-storage.types';

const PROFILE_PIC_PATH = 'profile-pics';

export class FirestoreProfilePicStorage implements iFirestoreProfilePicStorage {
  private rootRef: firebase.storage.Reference;

  private profilePicRef: firebase.storage.Reference;

  constructor(rootRef: firebase.storage.Reference) {
    this.rootRef = rootRef;
    this.profilePicRef = this.rootRef.child(PROFILE_PIC_PATH);
  }

  async upload(userId: string, file: File): Promise<StorageFile> {
    const fileRef = this.profilePicRef.child(`${userId}`);
    const snapshot = await fileRef.put(file);
    const fullPath = await snapshot.ref.getDownloadURL();

    return {
      name: file.name,
      fullPath,
    };
  }
}
